<!-- <div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto"> -->
@if(!_orderWizardService.loading$()) {
    <!-- @if(!_orderWizardService.getValue(x=>x.step03?.customerDto?.isMailConfirmed)){ -->
        <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
    <!-- } -->
}
@else {
    <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
}
    <!-- </div>
</div> -->

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <div class="max-w-4xl bg-white dark:bg-gray-900 rounded-tr-lg rounded-br-lg rounded-bl-lg shadow p-6 space-y-4">
        <div class="flex items-center">
            <span class="material-symbols-outlined text-danger-400 text-xl">
                unsubscribe
            </span>

            <div class="ltr:ml-[12px] rtl:mr-[12px]">
                <span class="block text-md mb-[2px] font-medium text-black dark:text-white text-lg font-semibold text-blue-900">
                    <!-- i18n: Confirmez vous la validité de cette adresse email: -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.email-ask-validation.span_01' | translate }} 
                </span>
            </div>
        </div>

        <!-- Description -->
        <p class="text-sm text-blue-700 mt-2">
                <!-- i18n: Confirmez vous la validité de cette adresse email:. -->
            <!-- {{ 'i18n.app.features.pages.order.wizard.step_03.email-ask-validation.p_01' | translate }}  -->
              {{ _orderWizardService.orderWizard$()?.step03?.customerDto?.email }}
        </p>

        <!-- Email affiché -->
        @if(!_orderWizardService.loading$()) {
            <!-- <form [formGroup]="form!" > -->
                <!-- <div class="mt-3 text-sm text-blue-800 font-medium"><ng-container *ngTemplateOutlet="tp_email"></ng-container></div>
                <ng-template #tp_email>
                    <div [formGroupName]="_orderWizardService.modelNames.step03.key">
                        <div [formGroupName]="_orderWizardService.modelNames.step03.fields.customerDto.key">
                            <corp-input 
                                [corp-loading]="_orderWizardService.loadingEmailValidation$()"
                                [formControlName]="_orderWizardService.modelNames.step03.fields.customerDto.fields.email.key">
                            </corp-input>
                        </div>
                    </div>
                </ng-template> -->

                <label class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100" >
                    <input
                        type="radio"
                         name="confirmation"
                        class="cursor-pointer accent-primary-500"
                        (change)="onChoiceChange(true)"
                        />
                    <span>{{ 'i18n.app.features.pages.order.wizard.step_03.email-ask-validation.input_01' | translate }} </span>
                </label>
                <label class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100" >
                    <input
                        type="radio"
                         name="confirmation"
                        class="cursor-pointer accent-primary-500"
                        (change)="onChoiceChange(false)" />
                    <span>{{ 'i18n.app.features.pages.order.wizard.step_03.email-ask-validation.input_02' | translate }} </span>
                </label>
            <!-- </form> -->
        }

        @if(isSendMail){
            <itsme-email-validation></itsme-email-validation>
        }
    </div>

</ng-template>

